import React, { useState } from 'react'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux';
import { addItemToBucket, removeItemFromBucket, selectTotalCost, selectTotalQuantity } from '../features/bucket/bucketSlice';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Link } from 'react-router-dom';
import TopBadges from '../components/TopBadges';

const Bucket = () => {
  const dispatch = useDispatch();

  const [showDetail, setShowDetail] = useState(false);

  const bucket = useSelector((state) => state.bucket.items)
  const totalCost = useSelector(selectTotalCost);
  const totalQuantity = useSelector(selectTotalQuantity);
  const addToBucket = (data) => {
    dispatch(addItemToBucket(data));
  };
  const removeFromBucket = (data) => {
    dispatch(removeItemFromBucket(data));
  };

  return (
    <div className='min-h-[100vh] p-4 container flex mx-auto'>
      <div className="flex bg-white w-[65%] p-3 flex-col">
        <h1 className='text-xl font-bold flex gap-2'>
          <Link to={"/menu"}>
             <span className='h-7 w-7 rounded-full border-light-secondary border-2 bg-gray-100 flex items-center justify-center font-bold cursor-pointer hover:bg-light-secondary text-light-secondary hover:text-white' ><IoIosArrowBack className='font-bold' size={20} /></span> 
          </Link>
           Items from your bucket</h1>
        <hr className='h-[2px] my-1 bg-black'/>

        <div className="item bg-light- w-full rounded-md py-4">
        {bucket.map((item) => (
                          <div className=''>
                    <div className="flex bg-gray-100 w-full gap-4 h-[90%] px-2 rounded-md rounded-b-none shadow-lg items-center mb-2">
                    <div className='flex h-full w-[25%]'>
                            <img src={item.image} alt='item' className='h-[90%] w-full' />
                    </div>
                    <div className='flex flex-col gap-1 w-full'>
                        <div className="flex justify-between items-center flex-row">
                            <h2 className='text-lg font-bold'>{item.title}</h2>
                            <h2 className='text-md font-semibold'>Rs. {item.price}</h2>
                        </div>
                            <p className='text-md font-semibold'>({item.quantity} Pc)</p>
                        <div className="flex justify-between">
                            <div className="flex w-[100px] justify-between items-center">
                                {item.quantity === 1 && (<div className="border rounded-md border-light-secondary p-1 cursor-pointer">
                                  <RiDeleteBin6Line onClick={() => removeFromBucket(item)} className='cursor-pointer' size={24}/>
                                  </div>)}
                                {item.quantity > 1 && (<div className="border rounded-md border-light-secondary p-1 cursor-pointer">
                                <AiOutlineMinus onClick={() => removeFromBucket(item)} className='cursor-pointer'size={24} />
                                </div>)} 
                                <text>{item.quantity}</text>
                                <div className="border rounded-md border-light-secondary p-2 cursor-pointer"> <AiOutlinePlus onClick={() => addToBucket(item)} /> </div>
               
                            </div>
                        </div>
                    </div>

                    </div>
                        </div>
                    ))}
        </div>

      </div>
      <div className='border w-[30%] h-[82vh] bg-white rounded-[15px] hidden lg:block'id="box">
                    <TopBadges/>
                    <h1 className='font-semibold text-2xl px-3'> {totalQuantity} Items Added</h1> 
                    <hr className='bg-light-secondary h-[4px] my-2' />
                    <div className="flex flex-col gap-2 p-2">
                     
                      <div className="flex flex-col bg-gray-100 w-full gap-4 min-h-10 p-4 rounded-md rounded-b-none shadow-lg justify-center">
                          <p>Special Instructions (Optional)</p>
                            <textarea name="" id="" cols="30" rows="2" placeholder='Add Cooking/Delivery Instructions (Optional)' className='p-2 rounded-md'></textarea>
                      </div>
                      <div className="flex flex-col bg-gray-100 w-full gap-4 min-h-10 p-4 items-center rounded-md rounded-b-none shadow-lg justify-center">
                          <h1 className='text-2xl font-bold'>Your Order</h1>
                          <div className='flex justify-between w-full'>
                           <p>Sub Total: </p>
                           <p>Rs: {totalCost}</p> 
                           </div>
                           <hr className='h-[2px] bg-gray-300 w-full'/>
                          <div className='flex justify-between w-full'>
                           <p>Total: </p>
                           <p>Rs: {totalCost}</p> 
                           </div>
                      </div>
                   
                    </div>
                    <div className='flex-end'>
  {/* <div class="border-b-10 border-transparent absolute h-0 w-0"></div> */}
  
  <div className="flex flex-end justify-between">
  <div id="ribbon" className='flex justify-between items-center'>
    <p>
    {totalQuantity} Items | Rs {totalCost}
    </p><Link to="/bucket">
    <p className='flex font-bold gap-2'>
      Checkout <span className='h-7 w-7 rounded-full bg-white flex items-center justify-center font-bold'><IoIosArrowForward color='black' size={20}/></span>
    </p>
  </Link>
    </div>
  
  </div>
</div>
        </div>
    </div>
  )
}

export default Bucket
